'use client';

import React, { createContext, useContext, ReactNode } from 'react';
import { Locale } from '@/i18n/config';
import ko from '@/locales/ko.json';
import en from '@/locales/en.json';

const translations = {
  ko,
  en,
};

type Translations = typeof ko;

interface LanguageContextType {
  locale: Locale;
  t: Translations;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export function LanguageProvider({
  children,
  locale,
}: {
  children: ReactNode;
  locale: Locale;
}) {
  const t = translations[locale] || translations.ko;

  return (
    <LanguageContext.Provider value={{ locale, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}